import axios from "axios";
import { Auth } from "aws-amplify";
import { backendConfig } from "../config/BackendConfig";
import { decryptToken, encryptToken } from "../utils/utils";
import { logoutUserFromCurrentDevice } from "../utils/constants/userConstants";

const axiosInstance = axios.create({});

let apiKey = null;
let secretKey = null;
let skey = null;
let congnitoUserDetails = null;
let decryptedToken = null;

const setBackendConfig = () => {
  apiKey = backendConfig.API_KEY;
  secretKey = backendConfig.SECRET_KEY_TO_ENCRYPT;
};

const setUserDataForAPI = (userCongnitoDetails) => {
  congnitoUserDetails = userCongnitoDetails;
  if (userCongnitoDetails?.attributes) {
    skey = userCongnitoDetails?.attributes["custom:skey"];
    decryptedToken = decryptToken(skey, secretKey);
  }
};

axiosInstance.interceptors.request.use(
  (request) => {
    /**Code to decrypt the received token and then again encrypt to send with API payload */
    const updateCurrentRequest = async () => {
      const currentTime = new Date().toISOString();
      const tokenExpiryTime = decryptedToken?.expirytime;

      if (currentTime > tokenExpiryTime || !tokenExpiryTime) {
        // fetch new skey
        congnitoUserDetails = await Auth.currentAuthenticatedUser();
        skey = congnitoUserDetails?.attributes["custom:skey"];
        decryptedToken = decryptToken(skey, secretKey);
      }
      if(request.url.includes("setClientData")){
        // console.info(`skey : ${skey}`);
        // console.info(congnitoUserDetails);
        // console.info(decryptedToken);
      }
      const tokenForAPICall = encryptToken(decryptedToken);

      request.headers["Content-Type"] = "application/json";
      request.headers["x-api-key"] = apiKey;
      request.data = {
        ...request.data,
        apiVersion: [2, 3],
        requestedUserId: congnitoUserDetails?.username,
        token: tokenForAPICall,
      };
      return request;
    };

    const updatedRequest = updateCurrentRequest();
    return updatedRequest;
  },
  (error) => {
    console.info("request error");
    console.info(error);
    Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const logoutUser = async () => {
      const deviceId =
        congnitoUserDetails.signInUserSession?.accessToken?.payload?.device_key;
      logoutUserFromCurrentDevice(congnitoUserDetails?.username, deviceId);
    };

    const invalidToken = "Error: Invalid Token";
    const invalidUser = "Error: User does not exist.";
    const errMsg = error?.response?.data?.message;
    console.info(errMsg);

    if (
      error?.response?.status === 400 &&
      (errMsg === invalidToken || errMsg === invalidUser)
    ) {
      // logout user and redirect him to signin screen
      logoutUser();
      console.info(`response errMsg : ${errMsg}`);
      console.info(error);
    } else {
      throw error;
    }
  }
);

export { axiosInstance, setBackendConfig, setUserDataForAPI };
